var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVarInformation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 100",
    style: {
      enableBackground: "new 0 0 200 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#CD0026;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VARINF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4734-4-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4936-0-4-5-5-0-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "text7930-4-6-6-7-0-7-7-8-9-6",
    className: "st0",
    d: "M71,14.9L47.2,72.5L29.6,30.8H18.1l22.9,53.8l0.2,0.6h11.2l0.2-0.6 l29.5-69.4l0.1-0.3L71,14.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7796-6-1-2-9-6-8-6-5-4-8",
    className: "st0",
    d: "M83.1,68.4H72.9l22.7-53.5h10.7l23.2,53.5h-10.7l-6.1-14.6H95l3.4-8.6 h10.8l-8.4-20.1L83.1,68.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path7798-5-6-9-8-1-3-6-8-8-5",
    className: "st0",
    d: "M139.9,68.3V14.9h24.3c11,0,16.4,4.8,16.4,14.3c0,6.5-4.2,11.8-12.8,16.1 l17,23.1h-12.6L156,45.1v-4.5c9.5-1.6,14.2-5.3,14.2-11c0-4-2.2-6-6.7-6H150v44.7H139.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "text7756-9-5-8-5-5-3-23-3-5-5-7-8-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5107",
    className: "st0",
    d: "M16.7,14.9v11h6.4v1.2h-8V14.9H16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5109",
    className: "st0",
    d: "M32.9,14.9v1.3h-6.4v4.1h6.1v1.3h-6.1v4.2H33v1.3h-8.1V14.9H32.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4721-4-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6944-5-1-1-2-2-3-5-8",
    className: "st0",
    d: "M66.8,71.2v13.9h-1.8V71.2H66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6946-6-57-5-0-5-1-5-9",
    className: "st0",
    d: "M72.1,85.1V74.9h1.2l0.3,1.3c0.9-0.8,2.1-1.2,3.4-1.2c2.6,0,3.8,1.3,3.8,3.8 v6.4H79v-6.5c0.2-1.1-0.6-2.1-1.7-2.3c-0.2,0-0.4,0-0.6,0c-1.1,0-2.2,0.5-2.9,1.3v7.4L72.1,85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6948-2-8-4-1-4-0-17-2",
    className: "st0",
    d: "M86,85.1V74.5c0-2.5,1.4-3.7,4.2-3.7c0.7,0,1.5,0.1,2.2,0.4v1.5 c-0.7-0.3-1.4-0.4-2.2-0.4c-1.6,0-2.4,0.7-2.4,2.2V75H91v1.4h-3.2v8.7H86z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6950-0-5-2-6-4-8-1-7",
    className: "st0",
    d: "M95.9,80c0,2.5,1,3.7,3,3.7s3-1.2,3.1-3.7c0-2.4-1-3.6-3.1-3.6 C97,76.4,95.9,77.6,95.9,80z M94.1,80c0-3.4,1.6-5.1,4.8-5.1s4.9,1.7,4.9,5.1s-1.6,5.1-4.9,5.1S94.2,83.4,94.1,80L94.1,80z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6952-3-8-0-4-1-1-1-9",
    className: "st0",
    d: "M107.9,85.1V74.9h1.2l0.3,1.3c0.9-0.8,2-1.3,3.2-1.3v1.5 c-1.1,0-2.2,0.4-2.9,1.3v7.4L107.9,85.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6954-56-3-9-0-6-0-5-5",
    className: "st0",
    d: "M116.7,85.1V74.9h1.2l0.3,1.3c0.9-0.8,2-1.3,3.2-1.3c1.2-0.1,2.3,0.4,3,1.4 c0.9-0.9,2.1-1.4,3.4-1.4c2.3,0,3.5,1.3,3.5,3.9v6.3h-1.8v-6.4c0-1.5-0.6-2.3-1.9-2.3c-1,0-2,0.5-2.7,1.3v7.4h-1.8v-6.4 c0-1.5-0.6-2.3-1.9-2.3c-1.1,0-2,0.5-2.7,1.3v7.4H116.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6956-6-2-7-6-1-9-2-4",
    className: "st0",
    d: "M135.3,82.1c0-2.1,1.4-3.1,4.1-3.1c0.9,0,1.8,0.1,2.6,0.2v-1 c0-1.2-0.9-1.8-2.8-1.8c-1.1,0-2.2,0.2-3.2,0.5v-1.4c1-0.3,2.1-0.5,3.2-0.5c3,0,4.5,1.1,4.5,3.2v7h-1l-0.6-1c-1,0.7-2.1,1-3.3,1 C136.5,85.2,135.3,84.1,135.3,82.1L135.3,82.1z M139.5,80.4c-1.6,0-2.3,0.6-2.3,1.7s0.6,1.7,1.8,1.7c1.1,0,2.2-0.3,3.1-1v-2.1 C141.2,80.4,140.3,80.4,139.5,80.4L139.5,80.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6958-67-4-3-1-6-2-7-3",
    className: "st0",
    d: "M147.9,73.3h1.1l0.4,1.7h2.8v1.4h-2.5v5.9c0,1,0.4,1.4,1.2,1.4h1.2v1.4h-1.7 c-1.7,0-2.6-0.9-2.6-2.7L147.9,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6960-6-1-7-8-3-4-6-1",
    className: "st0",
    d: "M158.1,75v10.1h-1.8V75H158.1z M158.1,71.3V73h-1.8v-1.8L158.1,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6962-7-1-2-9-3-9-1-2",
    className: "st0",
    d: "M163.9,80c0,2.5,1,3.7,3.1,3.7c2,0,3.1-1.2,3.1-3.7c0-2.4-1-3.6-3.1-3.6 C164.9,76.4,163.9,77.6,163.9,80z M162.1,80c0-3.4,1.6-5.1,4.9-5.1c3.2,0,4.8,1.7,4.8,5.1s-1.6,5.1-4.8,5.1S162.1,83.4,162.1,80 L162.1,80z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6964-7-59-6-8-5-1-4-3",
    className: "st0",
    d: "M175.8,85.1V74.9h1.2l0.3,1.3c0.9-0.8,2.1-1.3,3.4-1.3 c2.6,0,3.8,1.3,3.8,3.8v6.4h-1.8v-6.4c0.2-1.1-0.6-2.1-1.7-2.3c-0.2,0-0.4,0-0.6,0c-1.1,0-2.2,0.5-2.9,1.3v7.4L175.8,85.1z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVarInformation);
export default __webpack_public_path__ + "static/media/var-information.2c7af69e1a848a282d86b8ed77356045.svg";
export { ForwardRef as ReactComponent };